import {type MailDetailsWithMIME} from "components/src/api/admin/generated";
import {Download} from "components/src/common/Download";
import {DialogCloseCause} from "components/src/common/Enums";
import {RenderAlert} from "components/src/common/RenderAlert";
import {logger} from "components/src/utils/Logger";
import {useState} from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from "react-bootstrap/Modal";

/**
 * The owner should handle the OnClose event. The owner is responsible for closing the dialog.
 */
type OnClose = (closeCause : DialogCloseCause) => void;

interface MPAViewMailDialogProps {
    mailWithMIME : MailDetailsWithMIME
    onClose : OnClose
}

export const MPAViewMailDialog = ({mailWithMIME, onClose} : MPAViewMailDialogProps) => {
    /**
     * The error message if some general error occurred
     */
    const [errorMessage, setErrorMessage] = useState<string>();
    /**
     * If true, a Download component will be loaded which will download the binary property
     */
    const [download, setDownload] = useState(false);
    /**
     * The blob containing the binary file to download
     */
    const [blob, setBlob] = useState<Blob>();

    // called when the dialog is closed without clicking download
    const onHideDialog = () => {
        onClose(DialogCloseCause.Cancel);
    }

    /**
     * Is called when the download started. This should reset download to make sure the Download component is no
     * longer added.
     */
    const onDownload = () =>
    {
        // disable the Download component
        setDownload(false);
    }

    const downloadEmail = () =>
    {
        logger.debug("Download mail")

        if (mailWithMIME.mime === undefined) {
            throw new Error("mime is undefined")
        }

        setBlob(new Blob([mailWithMIME.mime], {type: "message/rfc822"}));

        // enable the Download component
        setDownload(true);
    }

    return (
        <Modal show={true} onHide={() => onHideDialog()} size="xl" fullscreen="lg-down" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Email with key {mailWithMIME.mailDetails.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <RenderAlert message={errorMessage} setMessage={setErrorMessage} tooltipPlacement={"bottom"}/>

                <InputGroup className="mb-3">
                    <Form.Control
                        className="font-monospace white-space-pre"
                        as="textarea"
                        defaultValue={mailWithMIME.mime??""}
                        rows={20}
                        autoFocus
                    />
                </InputGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={downloadEmail}>
                    Download
                </Button>
            </Modal.Footer>

            {download && blob !== undefined && (
                <Download blob={blob}
                          filename={`${mailWithMIME.mailDetails.name}.eml`}
                          onDownload={onDownload} />
            )}
        </Modal>
    );
}